export default __webpack_public_path__ + "static/media/sch6_w1024.192c1a49.jpg";